import type { MethodId } from "../design/methods";
import type { EntitySummary } from "../api/types";
import { localizedRecord } from "../i18n/localized";

export const METHOD_BY_CONNECTION: Record<EntitySummary["connectionMethod"], MethodId> = {
  direct_api: 1,
  agent: 2,
  file: 3,
  push: 4,
};

const HEALTH_LABEL = localizedRecord<EntitySummary["health"]>("domain.health", {
  healthy: "Healthy",
  failing: "Failing",
  stopped_reporting: "No documents",
  onboarding: "Onboarding",
});

export const HEALTH_PILL: Record<EntitySummary["health"], { status: string; label: string }> = {
  healthy: { status: "ok", get label() { return HEALTH_LABEL.healthy; } },
  failing: { status: "failed", get label() { return HEALTH_LABEL.failing; } },
  stopped_reporting: { status: "silent", get label() { return HEALTH_LABEL.stopped_reporting; } },
  onboarding: { status: "onboarding", get label() { return HEALTH_LABEL.onboarding; } },
};

export const STATUS_LABEL: Record<EntitySummary["status"], string> = localizedRecord("domain.status", {
  live: "Live",
  onboarding: "Onboarding",
  not_started: "Not started",
});
